import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PublicplaceFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M11.3333 8.2507C11.3333 7.33155 11.9482 6.55661 12.7875 6.31807C12.8741 5.94798 13.0326 5.54672 13.2963 5.17902C13.7831 4.50001 14.5867 4 15.7333 4C16.88 4 17.6835 4.50001 18.1704 5.17902C18.6242 5.81195 18.7667 6.54432 18.7667 7.04598V18.1926H20V20.0001H4V18.1926H6.3V16.954H5.06667V14.8117H6.3V13.7405H5.06667V11.5983H6.3H8.1H11.6333H13.4333H14.6667V13.7405H13.4333V14.8117H14.6667V16.954H13.4333V18.1926H16.9667V7.04598C16.9667 6.83357 16.8958 6.49482 16.7096 6.23516C16.5565 6.02157 16.2933 5.80751 15.7333 5.80751C15.1733 5.80751 14.9102 6.02157 14.7571 6.23516C14.6631 6.36624 14.5985 6.51747 14.5575 6.66242C15.0295 7.0298 15.3333 7.60462 15.3333 8.2507C15.3333 9.35987 14.4379 10.259 13.3333 10.259C12.2288 10.259 11.3333 9.35987 11.3333 8.2507ZM11.6333 18.1926V16.954H8.1V18.1926H11.6333ZM11.6333 13.7405V14.8117H8.1V13.7405H11.6333Z"
      />
    </SvgIcon>
  );
});
